import { createFileRoute } from "@tanstack/react-router";
import General from "../../app/views/competence/general";

export const Route = createFileRoute("/competence/general")({
  component: General,
});
